import { connect } from 'react-redux'
import { State } from 'store/reducers/index.types'
import {
  getCultureCode,
  getEmptySaleResourcesErrors,
  getEnvironment,
  getErrors,
  getHomePageUrl,
  getNetworkErrors,
  getPartner,
  getResourceFetchErrors,
  getScreenSize,
  getVersionFetchErrors
} from 'store/selectors'
import { MapStateToProps } from './types'

const mapStateToProps = (state: State): MapStateToProps => ({
  culture: getCultureCode(state),
  emptySaleResourcesErrors: getEmptySaleResourcesErrors(state),
  env: getEnvironment(state),
  errors: getErrors(state),
  homePageURL: getHomePageUrl(state),
  networkErrors: getNetworkErrors(state),
  partner: getPartner(state),
  resourceFetchErrors: getResourceFetchErrors(state),
  screenSize: getScreenSize(state),
  versionFetchErrors: getVersionFetchErrors(state)
})

export default connect(mapStateToProps)
